import React from 'react';
import type { UserSubmission as UserSubmissionModel } from 'models/projects/UserSubmission';
import type { FormSubmission as FormSubmissionModel } from 'models/projects/FormSubmission';
import { FormViewer } from 'components/forms/FormViewer';
import { TeamReview } from 'models/projects/TeamReview';
import TeamReviewComponent from './teamReviewComponent';

type Props = {
  submission: UserSubmissionModel | FormSubmissionModel;
  className?: string;
  isOwner?: boolean;
  isTeamMember?: boolean;
  projectId: string;
};

const UserSubmission: React.FC<Props> = ({ submission, className = '', isOwner = false, isTeamMember = false, projectId }) => {
  const isFormSubmission = (submission as any)?.type === 'FormSubmission' || !!(submission as any)?.form;
  const isProjectEstimationSubmission = (submission as any)?.type === 'ProjectEstimationSubmission';

  const form = isFormSubmission ? (submission as FormSubmissionModel).form : null;
  const teamReview = (submission as any).teamReview ?? null;

  const dateSubmitted = (submission as any).dateSubmitted;
  const hasValidDate = dateSubmitted && dateSubmitted !== '0001-01-01T00:00:00';

  return (
    <div className={`flex gap-6 ${className}`}>
      <div className="flex-1">
        {isProjectEstimationSubmission ? (
          <div className="p-4 bg-green-50 border border-green-200 rounded shadow-sm">
            <div className="flex items-center gap-2 text-green-700">
              <svg
                className="h-5 w-5 flex-shrink-0"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="text-sm font-semibold">Estimate accepted</span>
            </div>
            {hasValidDate && (
              <p className="mt-1 text-xs text-green-600">
                Accepted on {new Date(dateSubmitted).toLocaleDateString()}
              </p>
            )}
          </div>
        ) : isFormSubmission && form ? (
          <div className="h-full">
            <FormViewer
              form={form}
              formId={form?.id ?? ''}
              isDisabled={true}
            />
          </div>
        ) : (
          <div className="p-4 bg-white border rounded shadow-sm">
            <h3 className="text-base font-semibold mb-2">Submission</h3>
            <pre className="text-xs bg-gray-50 p-3 rounded overflow-auto">{JSON.stringify(submission, null, 2)}</pre>
          </div>
        )}
      </div>

      <div className="w-1/3">
        <div className="p-4 bg-white border rounded shadow-sm">
          <TeamReviewComponent teamReview={teamReview} isOwner={isOwner} isTeamMember={isTeamMember} projectId={projectId} />
        </div>
      </div>
    </div>
  );
};

export default UserSubmission;
